<!-- Gráfica circular de planes(afiliaciones) del organizador (Se usa en la vista src/views/admin/Home.vue)-->
<!-- El componente obtiene los datos de los eventos con una consulta de graphql
    Es necesario desarrollar un componente nuevo que consulte la información con express (ASÍ COMO LA NUEVA GRÁFICA CIRCULAR DE EVENTOS)
-->
<template>
  <v-row justify="center" class="fill-height">
    <v-col cols="12">
      <h2 class="headline font-weight-bold">Pagos de afiliaciones</h2>
      <v-divider></v-divider>

      <!-- LISTA DESPLEGABLE CON TODOS LOS PLANES DE UNA ORGANIZACIÓN -->
      <v-row justify="center">
        <v-col cols="12" md="6" class="pb-0">
          <v-select
            v-model="selectedPlan"
            :items="planData"
            label="Afiliación"
            no-data-text="Sin afiliaciones"
            :loading="loading"
            :value="selectedPlan"
            @change="updateGraph(selectedPlan)"
          ></v-select>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col cols="12" class="pt-0">
          <v-row justify="center">
            <v-col cols="9" md="8" lg="7" xl="5" class="pos-relative">
              <!-- GRÁFICA DE DONA -->
              <plan-doughnut-chart-config :chart-data="paymentTypesDataset" class="canvas"></plan-doughnut-chart-config>

              <!-- ACUMULADO DE VENTAS -->
              <div class="center-in-chart">
                <span
                  class="headline font-weight-bold"
                  v-if="total>0"
                  style="z-index:1;"
                >${{ total | currency }}</span>
                <span class="headline font-weight-bold" v-else>$0.00</span>
              </div>
            </v-col>

            <!-- ETIQUETAS DE MÉTODOS DE PAGO -->
            <v-col cols="12" class="text-center" v-if="planData.length>0">
              <span v-for="(method, index) in labels" :key="index">
                <v-chip class="mx-3 mx-lg-5" :color="colors[index]" small>{{ method }}</v-chip>
              </span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import planDoughnutChartConfig from "./planDoughnutChartConfig";
import { mapState, mapMutations, mapActions } from "vuex";
import { ChartConfig } from "@/constants/chart-config";
export default {
  components: {
    planDoughnutChartConfig
  },
  data() {
    return {
      planData: [],
      paymentTypesDataset: {
        labels: ["Spei", "Tarjeta", "Efectivo"],
        datasets: [
          {
            data: [1, 1, 1],
            backgroundColor: [
              ChartConfig.color.secondary,
              ChartConfig.color.success,
              ChartConfig.color.accent,
              ChartConfig.color.info,
              ChartConfig.color.danger
            ],
            borderWidth: [0, 0, 0],
            hoverBackgroundColor: [
              ChartConfig.color.secondary,
              ChartConfig.color.success,
              ChartConfig.color.accent,
              ChartConfig.color.info,
              ChartConfig.color.danger
            ]
          }
        ]
      },
      total: 0,
      selectedPlan: "",
      loading: false,
      colors: ["secondary", "success", "accent", "info", "danger"]
    };
  },
  computed: {
    ...mapState("plan", ["plans"]),

    /**
     * Función que devuelve los tipos de pago aceptados por el sistema.
     */
    labels() {
      return Object.keys(this.planData[0].paymentTypesData);
    }
  },
  methods: {
    ...mapActions("plan", ["fetchUserPlans"]),
    ...mapMutations("user", ["logout"]),
    /**
     * Función para dar formato al objeto de la base de datos para su uso en la gráfica.
     */
    async formatPlanData() {
      let paymentTypesData = {};
      this.loading = true;
      let profits = 0;
      let globalProfits = 0;
      let globalPaymentTypes = { Spei:0, Tarjeta:0, Efectivo:0 }
      // Validar si la sesión del usuario esta activa
      try {
        await this.fetchUserPlans();
      } catch(e) {
        if (e.message == 'GraphQL error: Autenticacion requerida ' || e.message == 'GraphQL error: jwt expired') {
          this.logout();
          this.$router.push("/login");
        }
      }
      if (this.plans.length > 0) {
        for (let plan of this.plans) {
            profits = plan.affiliations.reduce((total, affiliation) => {
            if (affiliation.estatus === "ACTIVE") {
              // INCREMENTO POR TIPO DE PAGO
              if (
                paymentTypesData.hasOwnProperty(
                  affiliation.paymentInformation.paymentType
                )
              )
                paymentTypesData[affiliation.paymentInformation.paymentType]++;
              else paymentTypesData[affiliation.paymentInformation.paymentType] = 1;

              // INCREMENTO DE GANANCIAS
              return total + affiliation.tier.amount;
            } else return total;
          }, 0);

          // CAMBIO DE NOMBRES DE TIPOS DE PAGO
          let formattedPaymentTypes = JSON.parse(
            JSON.stringify({
              Spei: paymentTypesData["BANK_TRANSFER"] || 0,
              Tarjeta: paymentTypesData["CARD"] || 0,
              Efectivo: paymentTypesData["CASH"] || 0
            })
          );

          // SUMATORIAS PARA EL VALOR TOTAL
          globalProfits+=profits;
          globalPaymentTypes = {
            Spei: globalPaymentTypes['Spei'] + (formattedPaymentTypes['Spei'] || 0 ),
            Tarjeta: globalPaymentTypes['Tarjeta'] + (formattedPaymentTypes['Tarjeta'] || 0),
            Efectivo: globalPaymentTypes['Efectivo'] + (formattedPaymentTypes['Efectivo'] || 0),
          }

          //OBTENER LOS EVENTOS QUE TENGAN GANANCIAS, SI TIENE 0 NO SE MUESTRA
          if (profits > 0) {
            this.planData.push({
              value: plan.name,
              text: plan.name,
              profits,
              paymentTypesData: formattedPaymentTypes
            });
          }

          profits=0;
          paymentTypesData = {};
          formattedPaymentTypes = {};
        }

        //AGREGAMOS EL VALOR TOTAL AL INICIO DEL ARREGLO
        this.planData.unshift({
          value: 'Todos',
          text: 'Todos',
          profits: globalProfits,
          paymentTypesData: globalPaymentTypes
        });

        this.selectedPlan = this.planData[0];

        // SI NO HAY GANANCIAS  MUESTRA UNA GRÁFICA POR DEFECTO
        if(this.planData[0].profits===0){
          this.paymentTypesDataset.labels=['Spei (SIN VENTAS)','Tarjeta (SIN VENTAS)','Efectivo (SIN VENTAS)']
          this.paymentTypesDataset.datasets[0].data = [ 1, 1, 1];
          this.total = 0;

        //EN CASO DE EXISITIR GANANCIAS ACTUALIZA LA GRÁFICA 
        }else{
          this.paymentTypesDataset.labels=['Spei','Tarjeta','Efectivo']
          let temp = { ...this.paymentTypesDataset };
          temp.datasets[0].data = Object.values(
            this.selectedPlan.paymentTypesData
          );
          this.paymentTypesDataset = temp;
          this.total = this.selectedPlan.profits;
        }

      }else{
        // EN CASO DE NO EXISTIR AFILIACIONES
        this.planData.unshift({
            value: 'Ninguna',
            text: 'Ninguna',
            profits: 0,
            paymentTypesData: { Spei:0, Tarjeta:0, Efectivo:0}
          });
        
        // SE AGREGAN LAS ETIQUETAS Y DATOS PARA MOSTRAR UNA GRÁFICA POR DEFECTO
        this.paymentTypesDataset.labels=['Spei (SIN VENTAS)','Tarjeta (SIN VENTAS)','Efectivo (SIN VENTAS)'];
        this.paymentTypesDataset.datasets[0].data = [ 1, 1, 1];
        this.total = 0;
        this.selectedPlan = this.planData[0];
      }

      this.loading = false;
    },

    /**
     * Función para actualizar la gráfica con un plan seleccionado.
     * @param { string } planName Nombre del plan que se desea inspeccionar.
     */
    updateGraph(planName) {
      let plan = this.planData.filter(plan => plan.value === planName)[0];
      this.total = plan.profits;
      let temp = { ...this.paymentTypesDataset };
      temp.datasets[0].data = Object.values(plan.paymentTypesData);
      this.paymentTypesDataset = temp;
    }
  },
  async mounted() {
    await this.formatPlanData();
  }
};
</script>
<style scoped>
.center-in-chart {
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}
.pos-relative {
  position: relative;
}
.canvas >>> .chartjs-render-monitor {
  z-index: 2;
  position: relative;
}
</style>